import React from 'react';
import { Flex } from '@atlaskit/primitives/compiled';
import { TableColumns } from '@atlassian/jira-projects-directory-v3-utils/src/constants.tsx';
import type { ActionsCell900BadPattern$key } from '@atlassian/jira-relay/src/__generated__/ActionsCell900BadPattern.graphql';
import type { ActionsCell237BadPattern$key } from '@atlassian/jira-relay/src/__generated__/ActionsCell237BadPattern.graphql';
import type { FavoriteCellFavouriteCell$key } from '@atlassian/jira-relay/src/__generated__/FavoriteCellFavouriteCell.graphql';
import type { KeyCell$key } from '@atlassian/jira-relay/src/__generated__/KeyCell.graphql';
import type { LastIssueUpdateCell$key } from '@atlassian/jira-relay/src/__generated__/LastIssueUpdateCell.graphql';
import type { LeadCell$key } from '@atlassian/jira-relay/src/__generated__/LeadCell.graphql';
import type { NameCell$key } from '@atlassian/jira-relay/src/__generated__/NameCell.graphql';
import type { ProjectCategoryCell$key } from '@atlassian/jira-relay/src/__generated__/ProjectCategoryCell.graphql';
import type { ProjectTypeCell$key } from '@atlassian/jira-relay/src/__generated__/ProjectTypeCell.graphql';
import type { UrlCellUrlCell$key } from '@atlassian/jira-relay/src/__generated__/UrlCellUrlCell.graphql';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import { ActionsCell } from './actions-cell/ActionsCell.tsx';
import { FavoriteCell } from './favourite-cell/FavoriteCell.tsx';
import { KeyCell } from './key-cell/KeyCell.tsx';
import { LastIssueUpdateCell } from './last-issue-update-cell/LastIssueUpdateCell.tsx';
import { LeadCell } from './lead-cell/LeadCell.tsx';
import { NameCell } from './name-cell/NameCell.tsx';
import { ProjectCategoryCell } from './project-category-cell/ProjectCategoryCell.tsx';
import { ProjectTypeCell } from './project-type-cell/ProjectTypeCell.tsx';
import { UrlCell } from './url-cell/UrlCell.tsx';

export type projectRefType = FavoriteCellFavouriteCell$key &
	KeyCell$key &
	NameCell$key &
	ProjectTypeCell$key &
	ProjectCategoryCell$key &
	LeadCell$key &
	LastIssueUpdateCell$key &
	UrlCellUrlCell$key &
	ActionsCell237BadPattern$key;

export const getTableRow = (
	projectRef: projectRefType,
	isAdminSettingsContext: Boolean = false,
	jiraQueryRef: ActionsCell900BadPattern$key | null,
) => ({
	cells: [
		{
			key: TableColumns.Favourites,
			content: <FavoriteCell project={projectRef} />,
		},
		{
			key: TableColumns.Name,
			content: <NameCell project={projectRef} />,
		},
		{
			key: TableColumns.Key,
			content: <KeyCell project={projectRef} />,
		},
		{
			key: TableColumns.Type,
			content: <ProjectTypeCell project={projectRef} />,
		},
		{
			key: TableColumns.Lead,
			content: <LeadCell project={projectRef} />,
		},
		{
			key: TableColumns.Category,
			content: <ProjectCategoryCell project={projectRef} />,
		},
		...(isAdminSettingsContext
			? [
					{
						key: TableColumns.LastIssueUpdate,
						content: <LastIssueUpdateCell project={projectRef} />,
					},
				]
			: []),
		{
			key: TableColumns.Url,
			content: isVisualRefreshEnabled() ? (
				<Flex alignItems="center">
					<UrlCell project={projectRef} />
					<ActionsCell project={projectRef} jiraQueryRef={jiraQueryRef} />
				</Flex>
			) : (
				<UrlCell project={projectRef} />
			),
		},
		...(!isVisualRefreshEnabled()
			? [
					{
						key: TableColumns.Action,
						content: <ActionsCell project={projectRef} jiraQueryRef={jiraQueryRef} />,
					},
				]
			: []),
	],
});
